export default __webpack_public_path__ + "static/media/imdb.8666d754.png";